module.exports = __webpack_public_path__ + "img/halle.050d5dac.jpg";